import { Tooltip } from "bootstrap";

$(document).ready(function () {
    const wishlistitems = JSON.parse(localStorage.getItem('wishlist') || "[]");
    updateWishlistCounter();

    if (wishlistitems.length < 1) {
        $('#wishlist-form').hide();
        $('#no-items-found-msg').show();
    }

    if ($("#wishlist-item-list").length) {

        $(".loader-container").show();

        $.ajax({
            url: "/merkzettel?type=5002&tx_uoproducts_wishlist%5Baction%5D=getItems&tx_uoproducts_wishlist%5Bwishlistitems%5D=" + JSON.stringify(wishlistitems),
            async: true,
            type: "GET",
            beforeSend: function () {
            },
            success: function (result) {
                const jsonResult = JSON.parse(result);
                const resultItems = JSON.parse(jsonResult.returnedItems);
                $(".loader").hide();
                renderItems(resultItems);
            },
            error: function (xhr, statusText, serverError) {
                console.log(statusText);
            }
        })

    }

    if($(".table").length) {
        let allWishlistButtons = $(".add-to-wishlist-button");

        $.each(allWishlistButtons, function (index, button) {

            const artId = $(button).data('item-number');

            wishlistitems.forEach(function (element) {
                if (element.artId === artId) {
                    $(button).hide();
                    $(button).next(".delete-from-wishlist-btn").show();
                }
            })
        });
    }


    $('.add-to-wishlist-button').on('click', function (e) {
        e.preventDefault();
        let product = {};
        product.uid = $(this).data('prdt-id');
        product.artId = $(this).data('item-number');
        product.name = $(this).data('prdt-name');

        let elementDoubles = false;
        wishlistitems.forEach(function (element) {
            if (element.artId === product.artId) {
                elementDoubles = true;
            }
        })

        if (!elementDoubles) {
            wishlistitems.push(product);
            const id = ".alert#add-alert-" + product.artId;
            const $elAlert = $(id);
            $elAlert.hide().show();
            setTimeout(function () {
                $elAlert.hide();
            }, 3000);
            $(this).hide();
            $(this).next(".delete-from-wishlist-btn").show()
        }

        updateWishlistCounter();

        localStorage.setItem('wishlist', JSON.stringify(wishlistitems));
    })

    $('.delete-from-wishlist-btn').on('click', function(e) {
        e.preventDefault();

        const $el = $(e.currentTarget);

        const toDelete = $(this).data('item-number');

        wishlistitems.forEach(function (element) {
            if (element.artId === toDelete) {
                const index = wishlistitems.indexOf(element);
                if (index > -1) {
                    wishlistitems.splice(index, 1);
                    console.log(wishlistitems);
                }


                const id = ".alert#delete-alert-" + toDelete;
                const $elAlert = $(id);
                $elAlert.hide().show();
                setTimeout(function () {
                    $elAlert.hide();
                }, 3000);
                $el.hide();
                $el.prev(".add-to-wishlist-button").show();

                localStorage.setItem('wishlist', JSON.stringify(wishlistitems));
                updateWishlistCounter();
            }
        })
    })

    $("#submitWishlistForm").on("click", function (e) {
        e.preventDefault();
        const wishlistForm = $("#wishlist-form");
        const confirmationMsg = $("#confirmation-msg");

        $.ajax({
            url: "/merkzettel?type=5002&tx_uoproducts_wishlist%5Baction%5D=requestItems",
            async: true,
            type: "POST",
            data: wishlistForm.serialize(),
            beforeSend: function () {
            },
            success: function (result) {
                const jsonResult = JSON.parse(result);
                if (jsonResult.success) {
                    $('input.error').removeClass('error');

                    wishlistForm.hide();

                    localStorage.removeItem("wishlist");
                    updateWishlistCounter();

                    if($(".success-link").attr("href")) {
                        window.location.href = $(".success-link").attr("href");
                    } else {
                        window.location.href = "/merkzettel";
                    }


                } else if (jsonResult.errorFields) {
                    $('input.error').removeClass('error');
                    jsonResult.errorFields.forEach(function (field) {

                        console.log(wishlistForm.find('input[type="text"][name="tx_uoproducts_wishlist[formData][' + field + ']"]'));

                        if (wishlistForm.find('input[type="text"][name="tx_uoproducts_wishlist[formData][' + field + ']"]').length && !wishlistForm.find('[name="tx_uoproducts_wishlist[formData][' + field + ']"]').next("p.error").length) {
                            wishlistForm.find('[name="tx_uoproducts_wishlist[formData][' + field + ']"]').addClass('error');
                        } else if (wishlistForm.find('input[type="email"][name="tx_uoproducts_wishlist[formData][' + field + ']"]').length && !wishlistForm.find('[name="tx_uoproducts_wishlist[formData][' + field + ']"]').next("p.error").length) {
                            wishlistForm.find('[name="tx_uoproducts_wishlist[formData][' + field + ']"]').addClass('error');
                        } else if (wishlistForm.find('input[type="checkbox"][name="tx_uoproducts_wishlist[formData][' + field + ']"]').length && !wishlistForm.find('[name="tx_uoproducts_wishlist[formData][' + field + ']"]').closest(".custom-control-input").next("p.error").length) {
                            wishlistForm.find('[name="tx_uoproducts_wishlist[formData][' + field + ']"]').addClass('error');
                        }
                    });
                }
            },
            error: function (xhr, statusText, serverError) {
                console.log(statusText);
            }
        })
    })

    function updateWishlistCounter() {
        $("a.wishlist-detail-link > span.items").text(wishlistitems.length);
    }

    function renderItems(items) {
        if ($("#wishlist-item-list").length) {
            $("#wishlist-item-list").empty();
            $.each(items, function (index, item) {
                $("#wishlist-item-list").append(`
                <ul class="row" id="wishlistitem-${item.articlnumber}">
                    <li class="col-md-4 col-lg-4 col-xl-3 col-xxl-2">
                        <img src="${item.imagePathForWishlistRendering}" alt="" title="">
                    </li>
                    <li class="col-md-8 col-lg-8 col-xl-4">
                        <h3>${item.name}</h3>

                        <p>${item.dimensionsize} ${item.color}</p>

                        <div class="d-none d-md-block d-xl-none">
                            <div class="row">
                                <div class="col">
                                    <h4>Artikelnummer</h4>
                                    
                                    <p>${item.articlnumber}</p>
                                </div>
                        
                                <div class="col">
                                    <h4>Anzahl</h4>

                                    <input type="text" class="form-control items" id="anzahl" name="tx_uoproducts_wishlist[formData][items][${item.articlnumber}]" aria-describedby="anzahl" value="1" required="true"/>
                                </div>

                                <div class="align-self-center align-self-xl-start text-end col align-self-center">
                                    <button class="delete-from-wishlist-btn" title="Entfernen" data-item-number="${item.articlnumber}"><i class="icon-trash"><span>Entfernen</span></i></button>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li class="col-5 col-sm-4 d-md-none d-xl-block col-xl">
                        <h4>Artikelnummer</h4>

                        <p>${item.articlnumber}</p>
                    </li>
                    <li class="col-3 col-sm-4 d-md-none d-xl-block col-xl">
                        <h4>Anzahl</h4>
                        
                        <input type="text" class="form-control items" id="anzahl" name="tx_uoproducts_wishlist[formData][items][${item.articlnumber}]" aria-describedby="anzahl" value="1" required="true" />
                    </li>
                    <li class="align-self-center align-self-xl-start col text-end col-sm-4  d-md-none d-xl-block  col-md-auto text-end">
                        <button class="delete-from-wishlist-btn" title="Entfernen" data-item-number="${item.articlnumber}"><i class="icon-trash"><span>Entfernen</span></i></button>
                    </li>
                </ul>
                `);
            });

            initDeleteItemsBtns();
        }
    }

    function initDeleteItemsBtns() {
        $('ul.row').on('click', 'button', function () {
            const toDelete = $(this).data('item-number');

            wishlistitems.forEach(function (element) {
                if (element.artId === toDelete) {
                    const itemId = '#wishlistitem-' + toDelete;
                    const index = wishlistitems.indexOf(element);
                    if (index > -1) {
                        wishlistitems.splice(index, 1);
                    }
                    $(itemId).remove();

                    localStorage.setItem('wishlist', JSON.stringify(wishlistitems));
                    updateWishlistCounter();
                }
            })

            if (wishlistitems.length < 1) {
                $('#wishlist-form').hide();
                $('#no-items-found-msg').show();
            }
        })
    }
});
